import { render, staticRenderFns } from "./RowBlockWritingOffCommissionMiniKasko.vue?vue&type=template&id=2bba6c42&"
import script from "./RowBlockWritingOffCommissionMiniKasko.vue?vue&type=script&lang=js&"
export * from "./RowBlockWritingOffCommissionMiniKasko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports